import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {OnlineEcomLabel} from 'modules/product-card/components/OnlineEcomLabel';
import style from './style.module.scss';

export const ProductShieldOnlineEcom = () => {
    const productData = useAppSelector(selectProductData);

    if (!productData?.price?.isOnlineEcom) {
        return null;
    }

    return (
        <div className={style.main}>
            <OnlineEcomLabel isAnimated={true} />
        </div>
    );
};
